import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {
  getHasLenses,
  getHasTeamLenses,
  getShouldHideAssignedConversations,
} from '../../../../store/featureFlags/featureFlagsSelectors';
import {WorkspacesEditor} from './workspacesEditor';

/*
 * Props.
 */

interface WorkspacesEditorContainerProps {}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<WorkspacesEditorContainerProps>()(() => ({
  hasLenses: getHasLenses,
  hasTeamLenses: getHasTeamLenses,
  shouldHideAssignedConversations: getShouldHideAssignedConversations,
}));

export const WorkspacesEditorContainer = connect(mapStateToProps)(WorkspacesEditor);
